import permissionsHandlers from './permissions';
import loginHandlers from './login';
import userManagmenet from './userManagement';
import registerHandlers from './register';

export default [...permissionsHandlers, ...loginHandlers, ...userManagmenet, ...registerHandlers];
